import { z } from 'zod';

export const activitySchema = z.object({
  id: z.string().uuid().optional(),
  projectId: z.string().uuid(),
  internalName: z.string().min(1, 'Interne naam is verplicht'),
  code: z.coerce.number().int('Code moet een geheel getal zijn').nonnegative('Code moet positief zijn'),
  price: z.coerce.number().nonnegative('Prijs moet positief zijn'),
  isActive: z.boolean().default(true),
});

export const createActivitySchema = activitySchema.omit({ id: true });
export const updateActivitySchema = activitySchema.partial().omit({ id: true });

export type ActivityFormData = z.infer<typeof createActivitySchema>;
export type ActivitySchema = z.infer<typeof activitySchema>;
